<template>
    <div class="page__content dashboard" v-if="campground">
        <div class="columns is-multiline is-mobile is-tablet">
            <div class="column is-12-mobile">
                <h2 class="page__headline" v-if="userFullName">{{ $t("dashboard.headline", {'name': userFullName}) }}</h2>
                <h2 class="page__headline" v-else>{{ $t("dashboard.genericHeadline") }}</h2>
<!--                Might get re-enable in the future -->
<!--                <p class="page__copy">-->
<!--                    {{ $t("dashboard.copy") }}-->
<!--                </p>-->
            </div>
        </div>
        <div
            v-if="campground.legal_documents.to_accept.length > 0"
            class="dashboard__warning"
        >
            <article class="message is-warning">
                <div class="message-header">
                    <span class="icon is-small">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{ $t("dashboard.legal_documents.header") }}
                </div>

                <div class="message-body is-clearfix">
                    <div v-if="campground.published">{{ $t("dashboard.warnings.documents.message") }}</div>
                    <div v-else>{{ $t("dashboard.warnings.documents.message_unpublished") }}</div>

                    <div class="my-4">
                        <ul>
                            <li
                                :key="doc.id"
                                v-for="doc in campground.legal_documents.to_accept"
                            >
                                <h3>{{doc.name}}, {{ $t("dashboard.legal_documents.valid_from")}} {{ getFormattedDate(doc.valid_from) }}</h3>
                                <p v-html="doc.info_text" />
                                <br>
                                <p>{{ $t("dashboard.legal_documents.confirm_text")}}</p>
                                <br>
                                <input
                                    :id="doc.id"
                                    type="checkbox"
                                    :value="doc.id"
                                    v-model="documentsToAccept"
                                >

                                <a
                                    :href="doc.documents.terms_of_service"
                                    target="_blank"
                                >
                                    <span>{{$t("dashboard.legal_documents.tos")}}</span>
                                </a>
                                <span> & </span>
                                <a
                                    :href="doc.documents.order_processing_conditions"
                                    target="_blank"
                                >
                                    <span>{{$t("dashboard.legal_documents.opc")}}</span>
                                </a>

                                <hr>
                            </li>

                        </ul>
                    </div>

                    <Modal
                        :title="$t('dashboard.warnings.documents.submitTitle')"
                        :submit-button="$t('dashboard.warnings.documents.submitButton')"
                        :onSubmit="acceptDocuments"
                    >
                        <p v-if="campground.published">{{ $t("dashboard.warnings.documents.submitText") }}</p>
                        <p v-else>{{ $t("dashboard.warnings.documents.submitText_unpublished") }}</p>

                        <template #activator>
                            <button
                                class="button is-primary"
                                :disabled="documentsToAccept.length === 0"
                            >
                                Bestätigen
                            </button>
                        </template>
                    </Modal>
                </div>
            </article>


            <article class="message is-warning" v-if="!checks.seasons">
                <div class="message-header">
                    <span class="icon is-small">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{ $t("generic.warning") }}
                </div>
                <div class="message-body is-clearfix">
                    {{ $t("dashboard.warnings.seasons.copy") }}
                    <router-link class="is-link is-pulled-right" exact :to="{ name: 'seasons', params: {lang: lang} }" @click.native="warningLinkClicked('seasons')">
                        <span class="icon is-small">
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </span>
                        <span>{{ $t("dashboard.warnings.seasons.button") }}</span>
                    </router-link>
                </div>
            </article>
            <article class="message is-warning" v-if="!checks.availabilities">
                <div class="message-header">
                    <span class="icon is-small">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    </span>
                    {{ $t("generic.warning") }}
                </div>
                <div class="message-body is-clearfix">
                    <span v-if="timeSince">
                        <span v-if="!lastApiCall.error" v-html="$t('dashboard.warnings.availabilities.copy1', {timeSince: timeSinceHr})"></span>
                        <span v-if="lastApiCall.error && !timeSinceTooLong" v-html="$t('dashboard.warnings.availabilities.copy2')"></span>
                        <span v-if="lastApiCall.error && timeSinceTooLong" v-html="$t('dashboard.warnings.availabilities.copy3', {timeSince: timeSinceHr})"></span>
                    </span>
                    <span v-else v-html="$t('dashboard.warnings.availabilities.copy4')"></span>

                    <router-link class="is-link is-pulled-right" exact :to="{ name: 'availabilities-redirect', params: {lang: lang} }" @click.native="warningLinkClicked('dayprices')">
                        <span class="icon is-small">
                            <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </span>
                        <span>{{ $t("dashboard.warnings.availabilities.button") }}</span>
                    </router-link>
                </div>
            </article>
        </div>

        <div class="columns is-multiline is-mobile is-tablet">
            <div class="column is-12-mobile is-12-tablet is-4-desktop">
                <div class="box box-shadow dashboard__bookings__box is-text-center">
                    <div class="subtitle is-5" v-html="$t('dashboard.newBookings.bookings', { num_all_bookings: campground.all_bookings, num_new_bookings: campground.new_bookings})"></div>
                    <div class="is-clearfix">
                        <div class="is-small">
                            <span class="icon is-small">
                                <i class="fa fa-arrow-right" aria-hidden="true"></i>
                            </span>
                            <router-link exact :to="{ name: 'bookings', params: {lang: lang} }" @click.native="bookingsLinkClicked()">
                                <span>{{ $t('dashboard.showBookings.bookings') }}</span>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="column is-12-mobile is-12-tablet is-5-desktop">
                <PmsInfoBox class="" />
            </div>


            <div class="column is-12-mobile is-12-tablet is-3-desktop">
                <div class="box box-shadow dashboard__info-box has-text-right">
                    <div class="columns">
                        <div class="column is-3">
                                <span class="icon is-big">
                                    <i class="fa fa-calendar" aria-hidden="true"></i>
                                </span>
                        </div>
                        <div class="column is-9">
                            <span class="dashboard__info-box__date-today">{{ today }}</span>
                        </div>
                    </div>
                    <div class="columns" v-if="campground.pricelist_ranges">
                        <div class="column is-3">
                                <span class="icon is-big">
                                    <i class="fa fa-euro" aria-hidden="true"></i>
                                </span>
                        </div>
                        <div class="column is-9">
                            {{ $t('dashboard.dayprice_info.prices_until') }} {{ this.getFormattedDate(campground.pricelist_ranges.max, 'LL') }}
                            ({{ $t('dashboard.dayprice_info.prices_range') }} {{ getTimeSince(campground.pricelist_ranges.max) }})
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dashboard__charts">
            <template v-if="getStatisticData">
                <div
                    v-for="(swiper, i) in swipers"
                    :key="swiper.key"
                    class="dashboard__chart-item-wrapper"
                >
            <div class="w-100">
                <select
                    name=""
                    id=""
                    class="w-100 dashboard__chart-item-title"
                    v-model="booking_statistic_type"
                    @change="onBookingStatisticTypeChange()"
                >
                    <option value="C">{{ $t('chart.select_count') }}</option>
                    <option value="U">{{ $t('chart.select_value') }}</option>
                </select>
             </div>
                    <select
                        v-model="swiper.titleKey"
                        class="dashboard__chart-item-title"
                        @change="onChartSelection(swiper)"
                    >
                        <option
                            v-for="option in Object.keys(getStatisticData)"
                            :key="option"
                            :value="option"
                        >
                            {{ $t(`dashboard.bookingStats.${option}`) }}
                        </option>
                    </select>

                    <swiper
                        :ref="swiper.key"
                        class="swiper dashboard__chart-item"
                        :options="swiperOptions"
                        @ready="onSwiperReady(swiper, i)"
                        @slide-change="onSlideChange(swiper, i)"
                    >

                        <swiper-slide
                            :key="`swiper-${type}-${booking_statistic_type}`"
                            v-for="(stat, type) in getStatisticData"
                        >
                            <Chart
                                v-if="swiper.isSwiperReady"
                                :type="type"
                                :data="stat"
                                :dataType="chartDataType"
                            />
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev" style="padding-left: 4rem" slot="button-prev"></div>
                    <div class="swiper-button-next" style="padding-right: 4rem" slot="button-next"></div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import Message from 'vue-bulma-message';
    import moment from 'moment';
    import {find} from 'lodash';
    import { PaymentList, Chart, Modal, PmsInfoBox } from '../../components';
    import {AppModel} from '../../../models';
    import { Api } from '../../../api';
    import {EventBus, Tracking} from '../../../utils';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    // import Swiper and modules styles
    import 'swiper/css/swiper.css';

    export default {
        name: 'dashboard',

        components: {
            Message,
            PaymentList,
            Chart,
            Swiper,
            SwiperSlide,
            Modal,
            PmsInfoBox,
        },

        created() {
            EventBus.$on(EventBus.BOOTSTRAP_DONE, this.onBootstrapDone);
            this.setTimeSince();
        },
        async mounted() {
            // campground.legal_documents.to_accept
            if(this.campground) {
                const legalDocuments = (await Api.documents.fetch()).data.legal_documents;

                this.campground.legal_documents.to_accept = legalDocuments.to_accept;
            }
        },
        data() {
            return {
                documentsToAccept: [],
                swiperOptions: {
                    effect: 'cube',
                    slidesPerView: 3,
                    spaceBetween: 0,
                    centeredSlides: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                },
                campground: AppModel.activeCampground,
                booking_statistic_type: 'C',
                checks: AppModel.checks,
                today: moment().format('LLLL'),
                lastApiCall: {
                    error: false,
                    date: new Date().toISOString(),
                },
                timeSince: null,
                timeSinceTooLong: false,
                timeSinceHr: '',
                swipers: [
                    { key: 'swiper-1', titleKey: '', isSwiperReady: false },
                    /* todo:gk Zwei gleiche verwirren momentan mehr */
                    /* { key: 'swiper-2', titleKey: '', isSwiperReady: false }, */
                ],
            };
        },

        computed: {
            userFullName() {
                if(!AppModel.user) {
                    return '';
                }

                if(!AppModel.user.first_name) {
                    return '';
                }

                if(!AppModel.user.last_name) {
                    return AppModel.user.first_name;
                }

                return `${AppModel.user.first_name} ${AppModel.user.last_name}`;
            },
            lang() {
                return AppModel.lang;
            },
            chartDataType() {
                return this.booking_statistic_type;
            },
            getStatisticData() {
                if(this.campground) {
                    if(this.booking_statistic_type === 'C') {
                        return this.campground.booking_statistic.count;
                    }
                    return this.campground.booking_statistic.value;
                }
            },
        },
        methods: {
            async acceptDocuments() {
                for(const id of this.documentsToAccept) {
                    const res = await Api.documents.submit(this.campground.slug, id);
                    // const index = this.campground.legal_documents.to_accept.findIndex((doc) => doc.id === id);

                    if(res.data.msg === 'okay') {
                        // todo: gk -> refresh der Seite
                        window.location.reload();
                        // this.campground.legal_documents.to_accept.splice(index, 1);
                    }
                }
            },
            onChartSelection(swiper) {
                const index = Object.keys(this.campground.booking_statistic.count).indexOf(swiper.titleKey);

                this.$refs[swiper.key][0].$swiper.slideTo(index);
            },
            onSwiperReady(swiper, index) {
                this.$nextTick(() => {
                    this.swipers[index].isSwiperReady = true;
                    this.onSlideChange(swiper, index);
                });
            },
            onSlideChange(swiper, index) {
                const currentIndex = this.$refs[swiper.key][0].$swiper.activeIndex;

                this.swipers[index].titleKey = Object.keys(this.campground.booking_statistic.count)[currentIndex];
                // this.swipers[index].statTitle = this.$t(`dashboard.bookingStats.${key}`);
            },
            onBootstrapDone() {
                this.campground = AppModel.activeCampground;
                this.checks = AppModel.checks;
                setTimeout(() => {
                    this.setTimeSince();
                }, 0);
            },

            getCampsiteTypes(campsites) {
                let sites = [];
                for(let i in campsites) {
                    sites.push(this.$t('generic.campsite_types.' + campsites[i] + '.abbr'));
                }
                return sites.join(' / ');
            },

            getSeasonNameById(id) {
                if(!id) return this.$t('generic.outOfSeason');
                let activeSeason = find(AppModel.activeCampground.seasons, {'id': id});
                return activeSeason.name;
            },

            warningLinkClicked(type) {
                Tracking.trackEvent('Dashboard', 'warningLink', type, null);
            },

            bookingsLinkClicked() {
                Tracking.trackEvent('Dashboard', 'newBookings', null, null);
            },

            setTimeSince() {
                if(!this.campground || !this.campground.last_api_call) {
                    return;
                }
                this.lastApiCall = this.campground.last_api_call;
                this.timeSince = moment(this.lastApiCall.date).fromNow(true);
                const diff = moment().diff(this.lastApiCall.date) / 3600000;
                this.timeSinceTooLong = diff > 5;
                this.timeSinceHr = moment(this.lastApiCall.date).fromNow(true);
            },
            getFormattedDate(date, format) {
                if(format) {
                    return moment(date).format(format);
                }
                return moment(date).format('MMM YYYY');
            },
            getTimeSince(date) {
                return moment(date).fromNow(true);
            },
            onBookingStatisticTypeChange() {
                if(this.booking_statistic_type === 'C') {
                    this.booking_statistic_data = this.campground.booking_statistic.value;
                } else {
                    this.booking_statistic_data = this.campground.booking_statistic.count;
                }
            }
        }
    };
</script>

<style lang='scss'>
    @import 'dasboard.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/dashboard/dashboard.vue